// src/pages/TestEmail.js
import React from "react";

const TestEmail = () => {
  const handleTestEmail = async () => {
    const data = {
      id: 110, // Cambia esto al ID de un comerciante real
      asunto: "🔍 Prueba de envío de email",
      mensaje: "Este es un email de prueba enviado desde el botón directo.",
    };

    try {
      const response = await fetch("https://panelcomerciantes.lagora.chat/api/sendEmailToComerciante.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (result.success) {
        alert("✅ Email enviado correctamente");
      } else {
        alert("❌ Error al enviar email: " + result.message);
      }
    } catch (error) {
      console.error("Error de red:", error);
      alert("❌ Error de red al enviar email");
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>🔧 Prueba de envío de email</h2>
      <button onClick={handleTestEmail}>Enviar email de prueba</button>
    </div>
  );
};

export default TestEmail;
